<script>
</script>

<div class="gw-error-banner">
    <slot />
</div>

<style>
    .gw-error-banner {
        color: red;
        font-size: 2em;
        font-weight: 600;
    }
</style>
